import React from 'react';
import { Link } from 'react-router-dom';
import { Store, Mail, MapPin, Phone } from 'lucide-react';

export const Footer = () => {
  // Function to open seller signup dialog
  const openSellerSignup = () => {
    window.dispatchEvent(new CustomEvent('openSignupDialog', { detail: { type: 'seller' } }));
  };

  // Function to open buyer signup dialog
  const openBuyerSignup = () => {
    window.dispatchEvent(new CustomEvent('openSignupDialog', { detail: { type: 'buyer' } }));
  };

  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="main-footer">
      <div className="container mx-auto px-4 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadgen-sync-1/artifacts/nsg95to1_Aalign_256x256.png" 
                alt="AALIGN" 
                className="w-8 h-8 rounded-lg object-contain"
              />
              <span className="text-xl font-bold text-white">AALIGN Marketplace</span>
            </div>
            <p className="text-sm text-slate-400 max-w-md mb-6">
              The leading global B2B lead generation marketplace connecting buyers with verified lead providers. 
              GDPR-compliant leads for international markets.
            </p>
            <div className="flex flex-col gap-2 text-sm">
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-slate-500" />
                <span>Stockholm, Sweden</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-slate-500" />
                <span>support@aalign.io</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Marketplace</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/marketplace" className="hover:text-white transition-colors">
                  Browse Leads
                </Link>
              </li>
              <li>
                <Link to="/marketplace?category=IT Security" className="hover:text-white transition-colors">
                  IT Security
                </Link>
              </li>
              <li>
                <Link to="/marketplace?category=Cloud" className="hover:text-white transition-colors">
                  Cloud & DevOps
                </Link>
              </li>
              <li>
                <Link to="/marketplace?category=Data/AI" className="hover:text-white transition-colors">
                  Data & AI
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold text-white mb-4">Resources</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button 
                  onClick={openSellerSignup} 
                  className="hover:text-white transition-colors text-left"
                >
                  Become a Seller
                </button>
              </li>
              <li>
                <button 
                  onClick={openBuyerSignup} 
                  className="hover:text-white transition-colors text-left"
                >
                  Start Buying
                </button>
              </li>
              <li>
                <a href="https://aalign.io" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  AALIGN Platform
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} AALIGN. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-500">
            <a href="https://aalign.io/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="https://aalign.io/terms-and-conditions" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Terms of Service</a>
            <a href="https://aalign.io/cookie-policy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
